import { TitleCasePipe } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { IconAndButtonCardComponent } from '@components/icon-and-button-card/icon-and-button-card.component';
import { environment } from '@environments/environment';
import { ConsultationRequestService } from '@services/consultation-request.service';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Component({
  selector: 'app-std-prevention-consultation-request-completed',
  templateUrl: './std-prevention-consultation-request-completed.component.html',
  styleUrls: ['../../consultation-request/consultation-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [IconAndButtonCardComponent, TitleCasePipe],
})
export class StdPreventionConsultationRequestCompletedComponent implements OnInit {
  public patientName: string;
  public transactionId: string;

  private consultationStorageService = inject(ConsultationStorageService);
  private consultationRequestService = inject(ConsultationRequestService);

  /**
   * Gets the phone number from the config.
   *
   * @returns {string} the site phone number
   */
  public get phone(): string {
    return environment.phone;
  }

  /**
   * Gets the business hours from the config.
   */
  public get businessHours(): string {
    return environment.businessHours;
  }

  /**
   * Initializes the component.
   */
  public ngOnInit(): void {
    this.patientName = this.consultationStorageService.patient?.name ?? '';
    this.transactionId = this.consultationStorageService.transactionId;
    this.consultationRequestService.clearLastConsultationRequestData();
  }
}
